'use strict';

module.exports = 'year|month|week|day|hour|minute|second|millisecond';


// WEBPACK FOOTER //
// ./~/sugar-date/range/var/DURATION_UNITS.js